import { WalletAddress } from '../Ether';
import { GemzUser, UserSchema, getUserFromSchema } from './User';

export enum FollowRelationship {
  None = 'none',
  Following = 'following',
  Follower = 'follower',
  Mutual = 'mutual',
}

/**
 * Schema for follower (the user following the other).
 */
export interface FollowerSchema {
  follower_id: number;
  follower_username: string;
  follower_image: string;
  follower_wallet_address: WalletAddress;
  follower_displayname: string;
}

/**
 * Schema for following user (the user being followed).
 */
export interface FollowingSchema {
  following_id: number;
  following_username: string;
  following_image: string;
  following_wallet_address: WalletAddress;
  following_displayname: string;
}

export interface FollowSchema {
  follower_id: number;
  following_id: number;
  created_at: number;
  relationship?: FollowRelationship;
  relation_to?: number;
}

export interface FollowData {
  followerId: number;
  followingId: number;
  createdAt: number;
  followerUser?: Partial<GemzUser>;
  followingUser?: Partial<GemzUser>;
  relationship?: FollowRelationship;
  relationTo?: number;
}

export const getUserFromFollowerSchema = (schema: FollowerSchema): Partial<GemzUser> => ({
  id: schema.follower_id,
  username: schema.follower_username,
  twitter: {
    handle: schema.follower_username,
    displayName: schema.follower_displayname,
    picture: schema.follower_image,
  },
  walletAddress: schema.follower_wallet_address,
});

export const getUserFromFollowingSchema = (schema: FollowingSchema): Partial<GemzUser> => ({
  id: schema.following_id,
  username: schema.following_username,
  twitter: {
    handle: schema.following_username,
    displayName: schema.following_displayname,
    picture: schema.following_image,
  },
  walletAddress: schema.following_wallet_address,
});

export const getFollowDataFromSchema = (
  schema: FollowSchema,
  extra?: {
    followerUserData?: Partial<GemzUser>,
    followingUserData?: Partial<GemzUser>,
    followerUserSchema?: Partial<UserSchema>,
    followingUserSchema?: Partial<UserSchema>,
  },
): FollowData => ({
  followerId: schema.follower_id,
  followingId: schema.following_id,
  createdAt: schema.created_at,
  relationship: schema.relationship,
  relationTo: schema.relation_to,
  followerUser: extra?.followerUserData ?? (extra?.followerUserSchema ? getUserFromSchema(extra.followerUserSchema as UserSchema) : undefined),
  followingUser: extra?.followingUserData ?? (extra?.followingUserSchema ? getUserFromSchema(extra.followingUserSchema as UserSchema) : undefined),
});

export const getFollowSchemaFromData = (
  data: FollowData
): FollowSchema => ({
  follower_id: data.followerId,
  following_id: data.followingId,
  created_at: data.createdAt,
  // not filling in other fields since they're not actually in the db schema
});
